export default "__VITE_ASSET__CUzh$I$H__"